import NextLink from 'next/link';

import { composeUrl } from '@utils/index';

type Props = {
    as?: string;
    children: React.ReactNode;
    href: string;
};

export const Link = ({ as, children, href }: Props) => (
    <NextLink href={href} as={composeUrl(as || href)}>
        {children}
    </NextLink>
);
